module.exports = __webpack_public_path__ + "img/plus.acd941bf.svg";